export default "__VITE_ASSET__ef6cf73f__"